import React from 'react';
import LoadingBar from 'react-top-loading-bar';

export default function TopLoadingBar(props) {
  return <LoadingBar color="#007399" {...props} />;
}
